var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0739 15.371C2.67223 15.0772 2.58912 14.5782 2.80381 13.9631L4.17505 9.93077L0.670773 7.44984C0.130588 7.06711 -0.118728 6.62286 0.0544083 6.14445C0.213694 5.67286 0.670773 5.44733 1.32869 5.45416L5.6294 5.48833L6.93831 1.42863C7.14607 0.793018 7.49927 0.444458 7.9979 0.444458C8.50346 0.444458 8.85666 0.793018 9.06442 1.42863L10.3733 5.48833L14.6671 5.45416C15.332 5.44733 15.789 5.67286 15.9483 6.14445C16.1145 6.62286 15.8721 7.06711 15.332 7.44984L11.8208 9.93077L13.1989 13.9631C13.4136 14.5782 13.3305 15.0772 12.9288 15.371C12.5202 15.6786 12.0216 15.5898 11.4745 15.1933L7.9979 12.6714L4.52132 15.1933C3.98114 15.5898 3.48251 15.6786 3.0739 15.371Z",
    fill: "#414141"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Star.015031575a3f4cb3b59562fc3a885e79.svg";